import { Button, Drawer } from 'antd';
import classNames from 'classnames';
import { ReactNode } from 'react';

import { ReactComponent as Arrow } from 'assets/icons/arrow-select.svg';
import { ReactComponent as FilterIcon } from 'assets/icons/filter.svg';

import { useDrawerTop, useTranslate } from 'hooks';

import styles from './index.module.scss';

type FilterProps = {
	children: ReactNode;
	onResetFields: () => void;
	isOpen: boolean;
	onOpen: () => void;
	onClose: () => void;
};

export const Filter = ({ children, onResetFields, isOpen, onOpen, onClose }: FilterProps) => {
	const t = useTranslate(['filterText', 'clearAllText']);

	const { top, scrollToTop } = useDrawerTop();
	return (
		<>
			<div aria-label="sidebar" role="button" onClick={onOpen} className="white-btn">
				<FilterIcon className={styles.iconFilter} /> {t.filterText}
			</div>
			<Drawer
				className={classNames(styles.drawer, { [styles.scrollDrawer]: !top })}
				title={
					<div className={styles.root}>
						<button
							onClick={() => {
								onClose();
								scrollToTop();
							}}
							className={styles.arrow}
						>
							<Arrow />
						</button>

						<Button type="link" className={styles.clear} onClick={onResetFields}>
							{t.clearAllText}
						</Button>
					</div>
				}
				width="100%"
				closable={false}
				onClose={() => {
					onClose();
					scrollToTop();
				}}
				open={isOpen}
				forceRender={true}
			>
				{children}
			</Drawer>
		</>
	);
};
